import type { ApiClient } from '../client';
import type { ListNotificationsResponse, MarkNotificationReadRequest } from '../types';

export function bindNotifications(client: ApiClient) {
  return {
    async listNotifications(params?: { limit?: number; unread_only?: boolean }) {
      const qs = new URLSearchParams();
      if (params?.limit != null) qs.set('limit', String(params.limit));
      if (params?.unread_only) qs.set('unread_only', 'true');
      const suffix = qs.toString() ? `?${qs}` : '';
      return client.request<ListNotificationsResponse>(`/notifications${suffix}`);
    },

    async markNotificationRead(body: MarkNotificationReadRequest) {
      return client.request<void>('/notifications/read', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async markAllNotificationsRead() {
      return client.request<void>('/notifications/read-all', {
        method: 'POST',
      });
    },

    async clearNotification(body: MarkNotificationReadRequest) {
      return client.request<void>('/notifications/clear', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async clearAllNotifications() {
      return client.request<void>('/notifications/clear-all', {
        method: 'POST',
      });
    },
  };
}
